import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill';
import Presval from './app/PresvalContainer';
import {HashRouter} from 'react-router-dom'
import ScrollToTop from './ScrollToTop';


ReactDOM.render(
    <HashRouter>
        <ScrollToTop>
            <Presval/>
        </ScrollToTop>
    </HashRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();